// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Retrieval resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient } from '../http.js';

export class RetrievalClient {
  constructor(private readonly http: HttpClient) {}

  /** Retrieve a previously-archived record by its archive id (tenant-scoped). A hot record returns state:available with the record; an archive/rehydrating record starts (or continues) rehydration and returns state:rehydrating. */
  async getArchivedRecord(recordId: string): Promise<{ state: string; record: Record<string, unknown>; metadata: Record<string, unknown>; etaHours: number }> {
    return this.http.get<{ state: string; record: Record<string, unknown>; metadata: Record<string, unknown>; etaHours: number }>(`/v1/retrieve/${recordId}`);
  }

  /** Rehydration status of a previously-archived record (tenant-scoped). */
  async getArchivedRecordStatus(recordId: string): Promise<{ accessTier: string; rehydrationStatus: string; requestedAt: string; readyAt: string; etaHours: number }> {
    return this.http.get<{ accessTier: string; rehydrationStatus: string; requestedAt: string; readyAt: string; etaHours: number }>(`/v1/retrieve/${recordId}/status`);
  }
}
